import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { TomosSection } from './components/TomosSection';
const META_PIXEL_ID = '1384540756930025';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen bg-black text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-0" data-mp="swgmvvugvest">
      <main data-id="element-1" data-mp="38b2ol1dva8p">
        <Hero data-id="element-2" data-mp="3ud1ftael3qb5" />
        <TestimonialsStrip data-id="element-3" data-mp="3udknlyaisybg" />
        <PainPoints data-id="element-4" data-mp="3uc9l01st9wlx" />
        <SolutionReveal data-id="element-5" data-mp="3uevpttobhy0g" />
        <TomosSection data-id="element-6" data-mp="d4e6dvbvvgxr" />
        <BonusSection data-id="element-7" data-mp="d4xpvgh6mddw" />
        <PricingSection data-id="element-8" data-mp="d45rxz0443kg" />
        <ExtendedTestimonials data-id="element-9" data-mp="d2l6qzzotwz9" />
        <Guarantee data-id="element-10" data-mp="851kpdwr0fwr" />
        <FAQ data-id="element-11" data-mp="86mev2f5hwu3" />
        <FinalCTA data-id="element-12" data-mp="86w3alkjrvxo" />
      </main>
      <Footer data-id="element-13" data-mp="83qhpgb4nc6p" />
    </div>;
}